<template>
    <div class="popup type2" :class="{ active: popupShow }">
        <div class="popup__inner">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>개인정보 수집·이용 동의</h2>
                    <button type="button" class="popup__close" @click="popupBtn"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <div class="text-box-scroll">
                        <div>
                            <p class="point-desc mb title03">
                                개인정보 수집·이용 동의 (필수)
                            </p>
                            1. 개인정보 의 수집·이용목적 : 나의 건강 관리 <br>
                            2. 수집하는 개인정보의 항목 <br>
                            <p class="point-desc font-main" v-if="$store.getters.getHost == 'H0006'">필수 정보 : 날짜, 시간, 혈압 (수축기혈압, 이완기혈압), 혈당(현재상태, 혈당수치), 체질량(성별, 키, 몸무게)</p>
                            <p class="point-desc font-main" v-if="$store.getters.getHost == 'H0008' && $route.path.includes('babyDiary')">필수 정보 : 날짜, 체중, 사진, 메모, 기분, 건강 상태</p>
                            <p class="point-desc font-main" v-if="$store.getters.getHost == 'H0008' && $route.path.includes('birthRecord')">필수 정보 : 날짜, 시간, 아기정보(이름, 태명, 성별, 사진, 신장, 체중, 머리둘레, 허벅지길이), 분만방법, 메모, 담당의</p>
                            3. 개인정보의 보유·이용기간 : <span class="point-desc c-red">회원 탈퇴 시 까지</span> <br>
                            4. 귀하는 위와 같은 개인정보 수집·이용에 동의하지 않으실 수 있습니다. 동의하지 않을 시 나의 건강관리 서비스가 제한될 수 있습니다.
                        </div>
                    </div>
                    <div class="checkbox-wrap">
                        <label for="agree01">
                            <input type="checkbox" name="agree01" id="agree01" v-model="agree">
                            <span class="checkbox-btn"></span>
                            <p><span class="c-red">*</span> 동의합니다</p>
                        </label>
                    </div>

                    <div class="botton-wrap">
                        <a href="javascript:;" class="sub-button c-main" @click="popupBtn">취소</a>
                        <a href="javascript:;" class="main-button c-main" @click="confirmAgreement">확인</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                popupShow: false,
                agree: false
            }
        },
        components: {
        },
        mounted() {
        },
        methods: {
            popupBtn() {
                this.popupShow = !this.popupShow
            },
            confirmAgreement() {
                if (!this.agree) {
                    alert("개인정보 수집·이용 동의에 동의가 필요합니다");
                    return
                }
                
                this.$parent.submit();
                this.popupShow = false
                this.agree = false
            }
        },
    }
</script>